var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGlobalError2 = function SvgGlobalError2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 341,
    viewBox: "0 0 321 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.545L252.083 0l67.545 252.083-252.083 67.545L0 67.545z",
    fill: "#B6D727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.52 115.562l-29.618-51.3-16.088 9.293 29.62 51.3 16.086-9.293zM201.935 132.079l45.009-38.563-12.137-14.107-44.952 38.563 12.08 14.107z",
    fill: "#0A9928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.799 238.669c-3.485-12.777-11.036-23.231-20.909-31.362 6.389-18.004-1.162-38.331-18.004-48.204l-39.491 69.692c15.1 8.712 33.102 6.389 45.299-4.065 6.388 4.646 10.455 11.616 12.778 19.166 2.904 9.292 1.161 19.165-3.486 27.877l18.585 10.454c7.55-12.777 9.874-28.458 5.228-43.558z",
    fill: "#0A9928"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M181.262 202.08l26.134 27.296 39.492-69.693-36.008-9.873-29.618 52.27z",
    fill: "#0A9928"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.353 182.914l-6.969-12.777-28.459 14.519-9.872-16.842 28.458-15.1-6.97-12.777-29.039 15.1-7.549-12.777-31.362 18.004c-16.842 9.292-23.811 29.039-18.585 46.462-6.969 6.388-12.776 15.681-15.68 26.134-4.066 15.1-2.324 30.781 5.226 44.139l18.585-10.454c-4.647-8.711-5.807-18.585-3.484-27.877 1.161-5.227 4.066-9.873 7.55-13.938 12.196 11.034 30.78 13.357 45.881 4.646l31.361-18.004-7.549-13.358 28.457-15.1zM204.491 207.888c5.46 0 9.873-4.42 9.873-9.874a9.868 9.868 0 00-9.873-9.873 9.87 9.87 0 00-9.874 9.873 9.87 9.87 0 009.874 9.874zM218.429 181.753c5.46 0 9.873-4.42 9.873-9.873a9.868 9.868 0 00-9.873-9.873 9.867 9.867 0 00-9.872 9.873 9.868 9.868 0 009.872 9.873z",
    fill: "#0A9928"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGlobalError2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "global-error2.a598c636d9aa6cef771b4d3d3de52885.svg";